module.exports = __webpack_public_path__ + "static/media/34d-min.39386068.png";